import React, {useState} from "react";
import { Button, Column, Columns, Input, Modal, Section, TextArea, Title } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import TrackingOptionsPicker from "../../Settings/TrackingCategory/TrackingOptionsPicker";


export default function CreateInvoiceModal({autofill, open, setOpen, endpoint, trackingOptions, trackingOptionObjects}){
    const [invoice, setInvoice] = useState(autofill ?? {});

    const getVat = (invoice) => {
        return (invoice.amount * 0.2).toFixed(2);
    };

    const getTotal = (invoice) => {
        return ((invoice.amount * 1.2) + parseFloat(invoice.no_vat_amount ?? 0)).toFixed(2);
    };

    const onChange = e => {
        let newInvoice = {...invoice, [e.target.name] : e.target.value};
        setInvoice(newInvoice);
    }

    const onTrackingOptionChange = e => {
        const toUpdate = {
            target: {
                name: "tracking_option",
                value: trackingOptionObjects[e.target.value]
            }
        }
        onChange(toUpdate);
    }

    const onSave = (data) => {
        const conf = {
            url: endpoint+"invoices",
            method: "post",
            data: data
        }
        axios(conf).then((res) => {
            toast.success("Invoice Created Successfully", {position: "top-right"})
            setOpen(false);
        }).catch(err => {
            toast.error("There was an error creating the invoice", {position: "top-right"})
        })
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() => {
                setOpen(false);
            }}
            closeOnBlur
        >
            <Modal.Content
                className={"wider-modal"}
            >
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Create Sale Invoice</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Customer</label>
                            <Input
                                name={"customer"}
                                type={"text"}
                                disabled={true}
                                value={invoice.customer ? invoice.customer.display_name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Description</label>
                            <TextArea
                                name={"description"}
                                onChange={onChange}
                                value={invoice.description}
                            />
                        </Column>
                        <Column>
                            <label className="label">Invoice Date</label>
                            <Input
                                value={invoice.invoice_date}
                                name={"invoice_date"}
                                type={"date"}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Invoice Number</label>
                            <Input
                                value={invoice.invoice_number}
                                name={"invoice_number"}
                                type={"text"}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <TrackingOptionsPicker
                                blank={true}
                                inlineEdit={false}
                                value={invoice.tracking_option}
                                options={trackingOptions}
                                onChange={onTrackingOptionChange}
                                editable={true}
                                label={"Tracking Option"}
                                name={"tracking_option"}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Vatable Amount</label>
                            <Input
                                type={"number"}
                                name={"amount"}
                                value={invoice.amount}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Non Vatable Amount</label>
                            <Input
                                type={"number"}
                                name={"no_vat_amount"}
                                value={invoice.no_vat_amount}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">VAT</label>
                            <Input
                                value={getVat(invoice)}
                                name={"vat"}
                                disabled={true}
                            />
                        </Column>
                        <Column>
                            <label className="label">Total Amount</label>
                            <Input
                                value={getTotal(invoice)}
                                name={"total"}
                                disabled={true}
                            />
                        </Column>
                        <Column></Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => {onSave(invoice)}}
                                isFullWidth
                            >
                              Save
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setInvoice({});
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );


}